import { Outlet } from "react-router-dom"
import { UserContext } from "../userContext"
import { useEffect, useMemo, useState } from "react"

export default function Index() {
	const [documentHeight, setDocumentHeight] = useState({ height: 0 })

    const app = useMemo(() => 
        <UserContext.Provider
            value={{
                parcelID: "",
                name: "",
                email: "",
                user_is_homestead: false,
                parcelHasHxCode: false,
                bypassResidencyDueToApplication: false,
                selectedExemptions: [],
                situsAddress: ""
            }}
        >
            <Outlet/>
        </UserContext.Provider>
    , [])
    
	useEffect(() => {
		sendMessage("heightChange", documentHeight.height.toString())
	}, [documentHeight])
    
	useEffect(() => {
		const resizeObserver = new ResizeObserver(entries => 
			setDocumentHeight({ height: entries[0].target.clientHeight })
		)
		resizeObserver.observe(document.body)
	}, [])

    function sendMessage(type, data) {
        parent.postMessage(JSON.stringify({type: type, data: data}), "*")
    }

    return (
        <>
        {app}
        </>
    )
}